module.exports = __webpack_public_path__ + "static/media/lettering-board1_v2.bd21d3dc.jpg";